import React, {useEffect, useState} from 'react';

import {Button, Modal} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import Assets from '../../../helpers/assets';
import Colors from '../../../helpers/Colors';
import {ModalStyles} from './CubbyModalStyles';
import {CubbyModalLoadingPanel} from "./CubbyModalLoadingPanel";

export function DispatchModeSelectionModal({isOpen, onCubbyInput, onPickUpCounterAssign, onClose}) {
    const [isLoading, setIsLoading] = useState(false);
    const style = ModalStyles();

    useEffect(() => {
        setIsLoading(false);
    }, [isOpen]);

    const renderBodyContent = () => {
        return (
            <div className={style.container}>
                <IconButton className={style.closeButton} onClick={onClose}><CloseIcon/></IconButton>
                <div className={style.body}>
                    <div className={style.leftPanel}>
                        <img src={Assets.deliveryMan.default} alt="delivery man"/>
                    </div>
                    <div className={style.rightPanel}>
                        <div className={style.titleText}>Please choose dispatch method</div>
                        <div className={style.subText}>Dispatch from cubby or pick-up counter</div>
                        <div className={style.buttonContainer}>
                            <Button type="submit"
                                    className={style.button}
                                    onClick={() => {
                                        setIsLoading(true);
                                        onPickUpCounterAssign()
                                    }}
                                    style={{color: Colors.grubtechBlue}}>
                                Pick-up Counter
                            </Button>
                            <Button type="submit"
                                    variant="contained"
                                    style={{backgroundColor: Colors.grubtechBlue, color: Colors.white}}
                                    onClick={() => {
                                        onCubbyInput()
                                    }}
                                    className={style.button}>Cubby
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            disableBackdropClick
            style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
        >
            {isLoading ? <CubbyModalLoadingPanel/> : renderBodyContent()}
        </Modal>
    );
}